import { POPUP_WIDTH, POPUP_HEIGHT, POPUP_NAME } from '../constants/nice'

import { IdentityVerificationInitiateData } from '@/services/account/identity-verification/types'

/**
 * NICE 본인인증 팝업 열기
 * @param niceData - NICE 인증 데이터
 * @returns Window 객체 또는 null
 */
export const openNiceVerificationPopup = (niceData: IdentityVerificationInitiateData): Window | null => {
  const left = (window.screen.width - POPUP_WIDTH) / 2
  const top = (window.screen.height - POPUP_HEIGHT) / 2
  const popupOptions = `width=${POPUP_WIDTH},height=${POPUP_HEIGHT},left=${left},top=${top},toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes`

  const params = new URLSearchParams({
    tokenVersionId: niceData.tokenVersionId,
    encData: niceData.encData,
    integrityValue: niceData.integrityValue,
    externalToken: niceData.externalToken,
  })

  const popupUrl = `${window.location.origin}/identity-verification/bridge?${params.toString()}`

  return window.open(popupUrl, POPUP_NAME, popupOptions)
}
